import React, { useContext } from 'react';
import { AuthContext } from '../ContextAuth/Context';
import { useNavigate } from 'react-router-dom';
import { BiSolidBarChartAlt2 } from 'react-icons/bi';
import { MdAccountCircle, MdArrowForwardIos, MdGppGood } from 'react-icons/md';
import { RiLogoutCircleRFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { clearStorage, getToken } from '../utils';

export const ProfileCard = () => {
  const contextConsume = useContext(AuthContext);
  const { setIsAuthenticated } = contextConsume;
  const navigate = useNavigate();
  const profileCardData = [
    {
      id: 1,
      icon: <MdAccountCircle />,
      name: 'Profile',
      path: '/settings/profile',
    },
    {
      id: 2,
      icon: <BiSolidBarChartAlt2 />,
      name: 'Rating',
      path: 'ratings',
    },
  ];
  const logout = () => {
    clearStorage();
    setIsAuthenticated(false);
    navigate('/', { replace: true });
    return;
  };
  const payload = getToken() || '';

  return (
    <div className='drop-shadow-md bg-p-wh max-w-[14rem] flex flex-col gap-6 box-border overflow-hidden'>
      <div className='flex flex-row px-6 justify-between'>
        <div className='flex flex-col pt-6'>
          <p className='text-p-bk text-base'> {payload.user.username}</p>
          <small className='text-s-bk text-xs'>{payload.user.email}</small>
          <small className='text-s-bk text-xs'>
            {payload.user.user_type.name}
          </small>
        </div>
        <div className='max-w-[2rem] text-xs rounded-b-2xl text-green-500 gap-2 items-center flex flex-col bg-green-500/25'>
          <p className='pr-14 -rotate-90 text-center'>Verify</p>
          <div className='text-lg pr-16 text-center -rotate-90'>
            <MdGppGood />
          </div>
        </div>
      </div>

      <div className=' flex flex-col border-b-hf border-f-bk'>
        {profileCardData.map((data) => {
          return (
            <div
              className='flex flex-row justify-between bg-p-wh hover:bg-f-bk border-t-hf border-f-bk text-p-wh hover:text-s-bk px-6 py-4'
              key={data.id}
            >
              <Link to={data.path} className='flex flex-row gap-2'>
                <div className='text-2xl text-p-bk'>{data.icon}</div>
                <p className=' text-p-bk'>{data.name}</p>
              </Link>
              <div className=''>
                <MdArrowForwardIos />
              </div>
            </div>
          );
        })}
      </div>
      <div
        className='flex flex-row justify-between px-6 py-2 bg-p-wh hover:bg-b-mc text-b-mc hover:text-p-wh rounded-lg mx-6 mb-6 gap-2 items-center border-hf border-f-bk'
        onClick={logout}
      >
        <p className='text-base'>Logout</p>
        <div className='text-2xl'>
          <RiLogoutCircleRFill />
        </div>
      </div>
    </div>
  );
};
